import React, { useState } from 'react';
import {
    Row,
    Col,
    Badge,
    Button,
    Card,
    CardHeader,
    CardBody,
    Input,
    InputGroup
} from "reactstrap";
import QRCode from "react-qr-code";
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';

const QrcodeForm = ({ onChange }) => {
    const [values, setValues] = useState({})

    const generate = () => {
        if (values.start) {
            try {
                const codeStart = parseInt(values.start);
                const codeEnd = parseInt(values.end || values.start);

                if (codeStart > codeEnd) {
                    toast.error("Código de fim precisa ser maior ou igual ao de início")
                } else {
                    const codes = [];
                    for (let index = codeStart; index <= codeEnd; index++) {
                        codes.push(index);
                    }
                    onChange(codes);
                }

            } catch (e) {
                toast.error("Valores inseridos precisam ser númericos!")
            }
        } else {
            toast.error("Preencha os códigos de início e fim!")
        }
    }
    const clickKey = (event) => {
        if (event.keyCode === 13) {
            generate()
        }
    }

    return <Row>
        <Col>
            <label className="label-input">De</label>
            <InputGroup>
                <Input className="input-qrcode"
                    placeholder="Insira o código de início"
                    type="number"
                    onChange={(e) => setValues({ ...values, start: e.target.value })}
                    onKeyDown={(e) => clickKey(e)}
                />
            </InputGroup>
        </Col>
        <Col>
            <label className="label-input">Ao</label>
            <InputGroup>
                <Input
                    placeholder="Insira o código de fim"
                    type="number"
                    onChange={(e) => setValues({ ...values, end: e.target.value })}
                    onKeyDown={(e) => clickKey(e)}
                />
            </InputGroup>
        </Col>
        <div className="btn-generate">

            <Button
                type="submit"
                className="btn-generate-qrcode"
                color="warning"
                onClick={generate}

            >
                Gerar
            </Button>

        </div>
    </Row >
}

const QrcodeList = ({ codes, copyClipboard }) => {
    const [ref, setRef] = useState()
    // const codes = [501, 456, 123, 401]
    return codes.length > 0 && <>
        <div className="qrcode-generated">
            <div>
                <p className="qr-code-generated-subtitle">QR Code gerado</p>
                <p className="qr-code-generated-information">Para copiar o link de cada QR Code, basta pressioná-lo.</p>
            </div>
            <div style={{ flex: 1 }}></div>
            <ReactToPrint
                copyStyles={true}
                trigger={() => {
                    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                    // to the root node of the returned component as it will be overwritten.
                    return <a href="#" style={{ marginLeft: 20 }}>
                        <Button
                            className="btn-print-qrcode"
                            color="warning"
                        // onClick={doLogin}
                        >
                            Imprimir QR Code
                        </Button>
                    </a>;
                }}
                content={() => ref}
            />
        </div>
        <div ref={ref => setRef(ref)}>
            <style>
                {`@media print {



            @page {
                width: 21cm;
                min-height: 29.7cm;
                padding: 2cm;
                margin: 1cm auto;
            }
            
            .row-print {
                margin: 0;
                border: initial;
                border-radius: initial;
                width: initial;
                min-height: initial;
                box-shadow: initial;
                background: initial;
                page-break-after: always;
                
            }

            .qrcode-col {
                page-break-inside: initial;
            }

            .badge-qrcode {
                color: #45445E;
                border: 0px;
                background: #E1E3F1;
                height: 32px;
                display: flex;
                justify-content: center;
                width: 95px;
                font-size: 14px;
                font-weight: bold;
                padding-top: 10px;
                border-radius: 20px;
                margin-top: 15px;
                margin-bottom: 15px;
            }
        }`}
            </style>
            <div className="page">
                <Card className="card-qrcode">
                    <CardBody>
                        <Row className="row-print">
                            {codes.map(({ data: { shortLink }, cod }) => {
                                return <Col style={{ marginBottom: 40, width: 600, height: 715 }} className="qrcode-col">
                                    <div className="qr-code" onClick={() => copyClipboard(shortLink)}>
                                        <QRCode size={512} value={`${shortLink}?cod=${cod}`} />
                                    </div>
                                    <div className="qrcode-ref">
                                        <Badge className="badge-qrcode" onClick={() => copyClipboard(shortLink)}>{`COD ${cod}`}</Badge>
                                    </div>
                                </Col>
                            })}
                        </Row>
                    </CardBody>
                </Card>
            </div>
        </div>

    </>

}

const QrCodeScreen = ({ onChange, codes, copyClipboard }) => {
    return <div className="content qr-code-page">
        <div className="qr-code-page-tile">QR Code</div>
        <div className="qr-code-page-subtitle">Gerar QR Code</div>
        <Card className="card-qrcode">
            <CardHeader>
                <CardHeader className="card-qrcode-header">
                    <span>Informe uma ou mais referências para gerar o QR code. Ex: COD 405 ao COD 423.</span>
                </CardHeader>
            </CardHeader>
            <CardBody>
                <QrcodeForm onChange={onChange} />
            </CardBody>
        </Card>
        <QrcodeList codes={codes} copyClipboard={copyClipboard} />
    </div>
}

export default QrCodeScreen;